import React, { useState } from 'react';
import "./FormStyles.css";
import Reveal from './Reveal';

const Form = () => {
  const [formData, setFormData] = useState({
    nombre: '',
    email: '',
    asunto: '',
    mensaje: ''
  });

  const [statusMessage, setStatusMessage] = useState('');   // Estado para el mensaje
  const [statusType, setStatusType] = useState('');         // 'success' o 'error'

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const response = await fetch('https://myportfolio-back-29bq.onrender.com/send-email', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
      });

      if (response.ok) {
        setStatusMessage('¡Correo enviado con éxito!');
        setStatusType('success');
        setFormData({ nombre: '', email: '', asunto: '', mensaje: '' }); // limpiar formulario
      } else {
        setStatusMessage('Hubo un error al enviar el correo.');
        setStatusType('error');
      }
    } catch (error) {
      setStatusMessage('Hubo un error de red. Intenta más tarde.');
      setStatusType('error');
    }

    // Limpiar mensaje después de 5 segundos
    setTimeout(() => {
      setStatusMessage('');
      setStatusType('');
    }, 5000);
  };

  return (
    <div className='form'>
      <form onSubmit={handleSubmit}>
        {statusMessage && (
          <div
            className={`alert-message ${statusType === 'error' ? 'error' : ''} show`}
            style={{ marginBottom: '1rem' }} // Para separar un poco del input siguiente
          >
            {statusMessage}
          </div>
        )}
        <Reveal as="div" className="field-group" delay={0}>
          <label>Nombre</label>
          <input
            type="text"
            name="nombre"
            value={formData.nombre}
            onChange={handleChange}
            required
          />
        </Reveal>
        <Reveal as="div" className="field-group" delay={80}>
          <label>Email</label>
          <input
            type="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
            required
          />
        </Reveal>
        <Reveal as="div" className="field-group" delay={160}>
          <label>Asunto</label>
          <input
            type="text"
            name="asunto"
            value={formData.asunto}
            onChange={handleChange}
            required
          />
        </Reveal>
        <Reveal as="div" className="field-group" delay={240}>
          <label>Mensaje</label>
          <textarea
            rows="6"
            name="mensaje"
            value={formData.mensaje}
            onChange={handleChange}
            placeholder='Escriba su mensaje'
            required
          />
        </Reveal>
        <Reveal as="div" delay={320}>
          <button className='btn' type="submit">Enviar</button>
        </Reveal>
      </form>
    </div>
  );
};

export default Form;